import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { useDeleteBusinessSetting } from '~/hooks/apis/business-traveller/useBusinessSettings';

import { BusinessSettingName } from '~/services/BusinessTraveller/BusinessTravellerService';

import { SETTING_LABELS } from '~/utils/businessTraveller/businessSettings';

interface Props {
  businessId: string;
  settingId: string;
  settingName: BusinessSettingName;
  isOpen: boolean;
  onClose: () => void;
}

export default function DeleteBusinessSettingDialog({ businessId, settingId, settingName, isOpen, onClose }: Props) {
  const deleteMutation = useDeleteBusinessSetting(businessId);
  const isLoading = deleteMutation.isPending;

  const handleDelete = () => {
    deleteMutation.mutate(settingId, {
      onSuccess: () => onClose(),
    });
  };

  return (
    <Dialog open={isOpen} onClose={() => !isLoading && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Delete {SETTING_LABELS[settingName]} setting</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Are you sure you want to delete the {SETTING_LABELS[settingName]} setting for this business? The business will
          fall back to the global default.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} variant="text" onClick={onClose}>
          No
        </Button>
        <Button onClick={handleDelete} disabled={isLoading} variant="contained" color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
